import React from "react";
import { getCheapestDealPrice } from "utils/packageDealPrice";
import { useTranslation } from "i18n";
import "./style.css";

const PackageDealCard = ({ deal, onClick, currency }) => {
  const { t } = useTranslation();
  const imageUrl = deal?.imageUrls?.[0] || "https://via.placeholder.com/400x250?text=Package+Deal";
  const { formatted: displayPrice, sign } = getCheapestDealPrice(deal?.price, currency);

  return (
    <div className="package-deal-card" onClick={() => onClick?.(deal)} role="button" tabIndex={0} onKeyDown={(e) => e.key === "Enter" && onClick?.(deal)}>
      <div className="package-deal-card__image-wrapper">
        <img src={imageUrl} alt={deal?.title} className="package-deal-card__image" />
        <div className="package-deal-card__overlay" />
        {deal?.featured && (
          <span className="package-deal-card__featured">{t("packageDeals.featured")}</span>
        )}
        <div className="package-deal-card__content">
          <h3 className="package-deal-card__title">{deal?.title}</h3>
          <div className="package-deal-card__meta">
            <span className="package-deal-card__duration">
              {deal?.duration}{" "}
              {deal?.duration === 1
                ? t("packageDeals.night")
                : t("packageDeals.nights")}
            </span>
            <span className="package-deal-card__price">
              {t("packageDeals.from")} {sign}{displayPrice}
            </span>
          </div>
          <span className="package-deal-card__cta">
            {t("packageDeals.viewTravelProgramme")}
            <span className="package-deal-card__cta-arrow">→</span>
          </span>
        </div>
      </div>
    </div>
  );
};

export default PackageDealCard;
